<div class="success-stories">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sec-header d-md-flex justify-content-between">
                    <h2>Success stories <span> of iQuanta toppers</span></h2>
                    <button mat-button [routerLink]="'/iquanta-toppers-meet'">See All</button>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid px-0">
        <div class="topper-images">
            <div class="logo-slider">
                <div>
                    <div class="toppers-image-card" *ngFor="let slide of slider1">
                        <img [src]="slide.img" alt="{{slide.percent}}" loading="lazy">
                        <svg (click)="playVideo(slide)" xmlns="http://www.w3.org/2000/svg" width="50" height="50"
                            fill="currentColor" class="bi bi-play-circle-fill" viewBox="0 0 16 16">
                            <path
                                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                        </svg>
                        <h6>{{slide.percent}}</h6>
                    </div>
                </div>
                <div>
                    <div class="toppers-image-card" *ngFor="let slide of slider1">
                        <img [src]="slide.img" alt="{{slide.percent}}" loading="lazy">
                        <svg (click)="playVideo(slide)" xmlns="http://www.w3.org/2000/svg" width="50" height="50"
                            fill="currentColor" class="bi bi-play-circle-fill" viewBox="0 0 16 16">
                            <path
                                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                        </svg>
                        <h6>{{slide.percent}}</h6>
                    </div>
                </div>
            </div>
            <div class="logo-slider logo-slider2">
                <div>
                    <div class="toppers-image-card" *ngFor="let slide of slider2">
                        <img [src]="slide.img" alt="{{slide.percent}}" loading="lazy">
                        <svg (click)="playVideo(slide)" xmlns="http://www.w3.org/2000/svg" width="50" height="50"
                            fill="currentColor" class="bi bi-play-circle-fill" viewBox="0 0 16 16">
                            <path
                                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                        </svg>
                        <h6>{{slide.percent}}</h6>
                    </div>
                </div>
                <div>
                    <div class="toppers-image-card" *ngFor="let slide of slider2">
                        <img [src]="slide.img" alt="{{slide.percent}}" loading="lazy">
                        <svg (click)="playVideo(slide)" xmlns="http://www.w3.org/2000/svg" width="50" height="50"
                            fill="currentColor" class="bi bi-play-circle-fill" viewBox="0 0 16 16">
                            <path
                                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                        </svg>
                        <h6>{{slide.percent}}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container" *ngIf="pageType == 'home'">
        <div class="row justify-content-between">
            <div class="col-md-6">
                <div class="topper-heading">
                    <h2>700+ 99%ilers<br>
                        & 1200s of CAT Toppers</h2>
                </div>
            </div>
            <div class="col-md-5">
                <div class="percetange-progress">
                    <div class="img">
                        <img src="https://media.iquanta.in/ui_images/new-home/horizontal-bar.gif"
                        loading="lazy" alt="700+ 99%ilers & 1200s of CAT Toppers">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>